import { useTranslations } from 'next-intl'
import { ReactNode } from 'react'

import {
  FilterEnum,
  FilterProvider,
  Floors,
  Options,
  PropertyTypes,
  PyeongSizes,
  ResetButton,
  RoomCounts,
  RoomDiscounts,
  UsingFee,
} from '@/features/room-filter'
import { MultiScrollProvider } from '@/shared/lib'
import { Button, Dialog } from '@/shared/ui'

import { ApplyButton } from './apply-button'

type TriggerProps = {
  target?: FilterEnum
  children: ReactNode
}

export const FilterDialogTrigger = ({ target, children }: TriggerProps) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      <Dialog.Content className="h-[760px] gap-0 p-0">
        <FilterDialog target={target} />
      </Dialog.Content>
    </Dialog.Root>
  )
}

export const FilterDialog = ({ target }: Pick<TriggerProps, 'target'>) => {
  const t = useTranslations('filter')

  return (
    <MultiScrollProvider target={target}>
      <FilterProvider>
        <Dialog.Header className="p-6">
          <Dialog.Title>{t('title')}</Dialog.Title>
          <Dialog.Description className="hidden">
            {t('description')}
          </Dialog.Description>
        </Dialog.Header>
        <div className="scrollbar thick flex grow flex-col space-y-6 overflow-y-auto *:pr-4 *:pl-6">
          <div className="mb-2 flex items-center justify-end">
            <ResetButton />
          </div>
          <RoomCounts />
          <UsingFee />
          <PropertyTypes />
          <PyeongSizes />
          <Floors />
          <Options />
          <RoomDiscounts />
        </div>
        <Dialog.Footer className="flex flex-row gap-2.5 p-6">
          <Dialog.Close asChild>
            <Button variant="outline" size="large" fullWidth>
              {t('button.close')}
            </Button>
          </Dialog.Close>
          <ApplyButton />
        </Dialog.Footer>
      </FilterProvider>
    </MultiScrollProvider>
  )
}
